/** Clear local auth (logout / CRM switch). */
export function clearAuthSession(): void {
  if (typeof window === 'undefined') return;
  try {
    [
      'jwt_token',
      'access_token',
      'user',
      'cognito_user',
      'user_tenant',
      'user_role',
      'user_business_area',
      'login_token',
      'login_username',
    ].forEach((key) => localStorage.removeItem(key));
  } catch {
    /* private mode / blocked storage */
  }
}

export function hasStoredSession(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return Boolean(
      localStorage.getItem('jwt_token') || localStorage.getItem('access_token')
    );
  } catch {
    return false;
  }
}
